module.exports = __webpack_public_path__ + "static/img/4.d72d322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/4.png
// module id = dO7y
// module chunks = 0